import { render, staticRenderFns } from "./newdateTable.vue?vue&type=template&id=aabba392&scoped=true&"
import script from "./newdateTable.vue?vue&type=script&lang=js&"
export * from "./newdateTable.vue?vue&type=script&lang=js&"
import style0 from "./newdateTable.vue?vue&type=style&index=0&id=aabba392&lang=less&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aabba392",
  null
  
)

export default component.exports